import { Box, CircularProgress, CircularProgressProps, Tooltip, Typography } from "@mui/material"

export function MatchScore (
    props: CircularProgressProps & { value: number; tooltipLabel?: string },
) {
    const { tooltipLabel, ...progressProps } = props
    const score = props.value
    const color = score >= 70 ? "success" : score >= 50 ? "warning" : "error"

    return (
        <Tooltip title={tooltipLabel ?? 'Recommendation score out of 100'}>
            <Box sx={{ position: 'relative', display: 'inline-flex' }}>
                <CircularProgress variant="determinate" {...progressProps} color={color} size={35} />
                <Box
                    sx={{
                        top: 0,
                        left: 0,
                        bottom: 0,
                        right: 0,
                        position: 'absolute',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <Typography
                        variant="caption"
                        component="div"
                        sx={{ color: 'text.secondary' }}
                    >{`${Math.round(props.value)}`}</Typography>
                </Box>
            </Box>
        </Tooltip>
    )
}
